module.exports = __webpack_public_path__ + "img/aiAvatar.92ff0af9.svg";